<selfai-platform-data-sources-library-data-frame-list
  [libraries]="libraries | async"
  (selectEvent)="onSelectFile($event)"
  (downloadEvent)="onFileDownload($event)"
  (uploadEvent)="onFileUpload($event)"
  (deleteEvent)="onDelete($event)"
></selfai-platform-data-sources-library-data-frame-list>
